import React from 'react';

type IconButtonProps = {
  id?: string;
  Icon: any;
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  variant?: 'primary' | 'danger' | 'outline' | 'primary-muted' | 'danger-muted';
  isDisabled?: boolean;
};

const variantToClass = {
  primary:
    'text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800',
  danger:
    'text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800',
  outline:
    'text-blue-700 border border-blue-700 hover:bg-blue-700 hover:text-white focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-full text-sm p-2.5 text-center inline-flex items-center dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:focus:ring-blue-800',
  'primary-muted':
    'text-white hover:bg-blue-700 focus:ring-2 focus:outline-none focus:ring-blue-300 font-medium rounded-full p-1 cursor-pointer',
  'danger-muted':
    'text-white hover:bg-red-700 focus:ring-2 focus:outline-none focus:ring-red-300 font-medium rounded-full p-1 cursor-pointer',
};

const IconButton = (props: IconButtonProps) => {
  return (
    <button
      id={props.id}
      type="button"
      onClick={props.onClick}
      className={variantToClass[props.variant || 'primary']}
      disabled={props.isDisabled}
    >
      <props.Icon />
      <span className="sr-only">Icon description</span>
    </button>
  );
};

export default IconButton;
